<template>
    <v-container fluid>
        <v-card class="text-center" style="height:100%">
            <v-card-subtitle class="text-center"><h3>{{serviceDetailName}}</h3></v-card-subtitle>
            <v-divider></v-divider>
            <v-card-text  style="height:100%">
                <v-row>
                    <v-col cols="12">
                        <img :src="content" />
                    </v-col>
                </v-row>
                 <v-row>
                     <v-spacer></v-spacer>
                     <v-col cols="1" class="text-right">
                        <v-btn text @click="previous" :disabled="curImageIdx == 0"><v-icon>mdi-arrow-left-bold</v-icon></v-btn>
                    </v-col>
                     <v-col>รูปที่ {{curImageIdx + 1}} จาก {{images.length}}</v-col>
                     <v-col cols="1">
                        <v-btn text @click="next" :disabled="curImageIdx == (images.length - 1)"><v-icon>mdi-arrow-right-bold</v-icon></v-btn>
                    </v-col>
                     <v-spacer></v-spacer>
                 </v-row>
            </v-card-text>
            <v-card-actions class="text-right">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="close">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: 'ImagePreview',
    data: () => ({
        curImageIdx: -1,
        images: [],
        content: '',
        serviceDetailName: ''
    }),
    methods: {
        setContent(key, images, serviceDetailName) {
            this.serviceDetailName = serviceDetailName;
            this.images = images;
            this.showImage(key);
        },
        showImage(key) {
            if (!this.images) return;
            for (var i = 0; i < this.images.length; i++) {
                let image = this.images[i];
                let check = false;
                if (image.imageKey) {
                    check = (key == image.imageKey);
                    if (check) {
                        this.curImageIdx = i;
                        this.content = process.env.VUE_APP_SERVICE_ROOT + "/common/image/" + key;
                    }
                } else {
                    check = (key == image.upload.uuid);
                    if (check) {
                        this.curImageIdx = i;
                        this.content = image.dataURL;
                    }
                } 
            }
            return;
        },
        previous() {
            let image = this.images[this.curImageIdx - 1];
            let key = image.imageKey ? image.imageKey : image.upload.uuid;
            this.showImage(key);
        },
        next() {
            let image = this.images[this.curImageIdx + 1];
            let key = image.imageKey ? image.imageKey : image.upload.uuid;
            this.showImage(key);
        },
        close() {
            this.$emit("close");
        }
    }
}
</script>